const isLevelSensor = sensors => sensors?.[0]?.subType === "level";

export default isLevelSensor;
